import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { Header, AuthLink, FormContainer } from './shared'
import ConfirmEmailForm from './ConfirmEmailForm'
import SpinnerContainer from '../display/SpinnerContainer'
import Spinner from '../display/Spinner'

const Wrapper = styled.div``

class ConfirmEmail extends React.Component {
  render() {
    const { auth } = this.props
    return (
      <Wrapper>
        <Header>
          {auth.currentUser && (
            <AuthLink to="/confirm-email">
              <strong>Confirm</strong> Your Details
            </AuthLink>
          )}
        </Header>
        {(auth.loading || !auth.currentUser) && (
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        )}

        {!auth.loading && auth.currentUser && (
          <FormContainer>
            <ConfirmEmailForm />
          </FormContainer>
        )}
      </Wrapper>
    )
  }
}

export default connect(({ auth }) => ({ auth }))(ConfirmEmail)
